module.exports = __webpack_public_path__ + "static/favicon-c27a2f40545fb9321c8d49d14f644bca.png";